import ContentEditor from './ContentEditor';

export type { ContentEditorProps } from './ContentEditor';

export default ContentEditor;
